import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import React from "react";
import RootLayout from "./src/layouts/RootLayout";
import "./src/shared/styles/global.css";
import { theme } from "./src/theme";

export const wrapPageElement = ({ element }) => {
  return (
    <MantineProvider theme={theme}>
      <RootLayout>{element}</RootLayout>
    </MantineProvider>
  );
};
